import { Check, X } from "lucide-react";

export default function PricingCard({ tier, featured, index = 0 }) {
  const num = String(index + 1).padStart(2, "0");

  return (
    <div
      data-testid={`pricing-card-${tier.id}`}
      className={`hover-rise nm-fade-up relative bg-[var(--theme-surface)]/60 backdrop-blur-sm border border-[var(--theme-border)] rounded-2xl p-7 md:p-9 flex flex-col overflow-hidden ${
        featured ? "md:scale-[1.04] md:-translate-y-2 border-[var(--accent)]/60" : ""
      }`}
      style={{ animationDelay: `${index * 90}ms` }}
    >
      {/* Mega number watermark */}
      <div className="mega-num absolute -top-4 -right-2 text-[180px] leading-none select-none">
        {num}
      </div>

      {/* Hazard tape on featured */}
      {featured && (
        <div className="absolute top-0 left-0 right-0 h-1 hazard" />
      )}

      <div className="relative z-10 flex flex-col flex-grow">
        <div className="flex items-center justify-between mb-3">
          <div className="bracket">[ T_{num} // {tier.id.toUpperCase()} ]</div>
          {featured && (
            <span className="font-mono text-[9px] font-bold tracking-widest bg-[var(--accent)] text-black px-2 py-1 hard-pulse">
              ▲ PRIORITY
            </span>
          )}
        </div>

        <h3
          data-text={tier.name}
          className="glitch font-display text-3xl md:text-4xl uppercase tracking-wide mb-5 leading-tight"
        >
          {tier.name}
        </h3>

        <div className="flex items-baseline gap-3 mb-1">
          <span
            data-testid={`price-${tier.id}`}
            className="font-display text-4xl md:text-5xl text-[var(--accent)] tracking-wide"
          >
            {tier.price}
          </span>
        </div>
        {tier.unit && (
          <div className="font-mono text-[10px] text-[var(--muted)] uppercase tracking-[0.2em] mb-6">
            // {tier.unit}
          </div>
        )}

        {tier.description && (
          <p className="text-sm text-[var(--muted)] leading-relaxed mb-6 border-l-2 border-[var(--accent)] pl-4">
            {tier.description}
          </p>
        )}

        <ul className="space-y-2.5 mb-2 flex-grow">
          {tier.features.map((f, i) => (
            <li key={i} className="flex items-start gap-3 text-sm">
              <span
                className={`flex-shrink-0 w-5 h-5 mt-0.5 flex items-center justify-center border ${
                  f.ok
                    ? "bg-[var(--accent)] border-[var(--accent)] text-black"
                    : "bg-transparent border-red-500/60 text-red-500"
                }`}
              >
                {f.ok ? <Check size={12} strokeWidth={3} /> : <X size={12} strokeWidth={3} />}
              </span>
              <span className={f.ok ? "text-[var(--text)]" : "text-[var(--muted)] line-through decoration-red-500/40"}>
                {f.text}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

